import styled, { css } from 'styled-components';
import { rem, transparentize } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import IconCounter from '../Icon/iconCounter';
import IconComments from '../Icon/IconComments';

const StyledOptionsSocialMedia = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
  position: relative;
  width: 100%;
`;

/**
 * Message that appears
 * when user click over like or readLater
 */

// Message content
const StyledBoxOption = styled.div`
  align-items: center;
  background: ${transparentize(0.15, '#000')};
  color: ${props => props.theme.colors.light};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 0;
  padding: ${rem('1px')} 0;
  position: absolute;
  text-align: center;
  top: 0;
  transition: all 0.5s ease-in-out;
  width: 100%;
  z-index: -1;

  ${props =>
    props.active &&
    css`
      opacity: 1;
      z-index: 10;
    `};
`;
const StyledBoxOptionHome = StyledBoxOption.extend`
  ${mediaqueries.greaterThan('mobile')`
    height: auto;
    top: ${rem('43px')};
    left: auto;
    right: 0;
    max-width: ${rem('147px')};
  `};
`;

// Message Text
const StyledBoxText = styled.span`
  font-size: ${props => props.theme.fontSize.xsmall};
  font-family: ${props => props.theme.fonts.medium};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

/**
 * Icons
 */
// Iconos by default
const StyledIcon = styled(IconCounter)`
  margin: 0;
  fill: ${props => props.theme.colors.dark};

  ${props =>
    props.active &&
    css`
      fill: ${props.theme.colors.primary};
    `};

  ${mediaqueries.greaterThan('desktop')`
    height:${rem('36px')};
    width:${rem('36px')};
  `};
`;

const StyledIconForColumn = styled(Icon)`
  fill: ${props => props.theme.colors.light};
  ${mediaqueries.between('mobile', 'desktop')`
    fill: ${props => props.theme.colors.dark};
  `};
`;

// Icons on home
const StyledIconArticle = StyledIcon.extend`
  fill: ${props => props.theme.colors.light};

  ${props =>
    props.active &&
    css`
      fill: ${props.theme.colors.primary};
    `};
  ${mediaqueries.greaterThan('mobile')`
    height:${rem('24px')};
    width:${rem('24px')};
    fill: ${props => props.theme.colors.dark};

     ${props =>
       props.active &&
       css`
         fill: ${props.theme.colors.primary};
       `};
  `};
`;

// Icon comments
const StyledIconComments = styled(IconComments)`
  height: 1.45rem;
  margin: 0;

  ${mediaqueries.greaterThan('desktop')`
     display: none;
  `};
`;

const StyledIconCommentsForColumn = StyledIconComments.extend`
  fill: ${props => props.theme.colors.light};
  ${mediaqueries.between('mobile', 'desktop')`
    fill: ${props => props.theme.colors.dark};
  `};
  ${mediaqueries.greaterThan('desktop')`
     display: inline;
  `};
`;

// Icon comments in home
const StyledIconCommentsArticle = StyledIconComments.extend`
  fill: ${props => props.theme.colors.light};

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    fill: ${props => props.theme.colors.dark};
  `};
`;

export {
  StyledOptionsSocialMedia,
  StyledIcon,
  StyledIconForColumn,
  StyledIconArticle,
  StyledIconComments,
  StyledIconCommentsForColumn,
  StyledIconCommentsArticle,
  StyledBoxOption,
  StyledBoxOptionHome,
  StyledBoxText
};
